/**
 * Created by Jasmine on 2018/6/6.
 */

import { observable, computed, action, toJS } from "mobx";
import { request, apis } from '../../utils/net';
import Utils from '../../utils/Utils';

const store = observable({
    // 商户状态数据
    bussinessStatus: {
        detail: "", //
        name: "", // 企业名称
        tax_code: "", // 企业税号
        reason_failure: "", // 失败原因（审核失败返回）
        invoice_statistics: {}, // 企业发票情况统计（审核通过返回)
        source: 1, // 商户来源：1 => 'PC端',2 => '云票儿商家版',3 => '云平台',4 => '百望插件', 5 => '服务商平台', 6 => '开放平台',7 => '管理后台',8 => '云票儿',9=> '万达',10 => '海鼎',11 => '区块链',12 => '集团',
        industry: "", // 行业标识：'tx' => '通信', 'jt' => '交通', 'lx' => '票务/旅行', 'zfpt' => '第三方支付平台', 'cy' => '快递/物流', 'kd' => '餐饮', 'ds' => '电商', 'tc' => '停车', 'wy' => '物业', 'shfw' => '生活服务', 'xxls' => '线下零售', 'jy' => '教育', 'yl' => '医疗', 'jd' => '酒店', 'jyz' => '加油站', 'qt' => '其他'
        status: "", // 商户注册状态 0:审核中，1:审核成功，2:审核失败，4：商户为选择套餐，或者已取消订单，5：待支付， 6：是商户注册信息未完善
        can_renew_product: 1, // 是否允许购买套餐（我的订单）标识：0|不允许 1|允许
        max_account: 0, // 帐号管理里面的可免费添加帐号数量
        tax_disk_type: 0, // 税盘类型标识：0初始值, 1航天金税盘，2百望税控盘
    },
    quotaWarn: false,      // 是否打开开票限额警告
    sysCompleteData: null, // 系统信息完整性通知数据

    /**
     * 获取用户注册状态
     */
    getBussinessStatus() {
        let promise = request({ url: apis.getBusinessStatus });

        promise.then(res => {
            this.bussinessStatus = { ...this.bussinessStatus, ...(res || {}) };
        });

        return promise;
    },

    get isBlock() { // 是否是区块链商户
        return this.bussinessStatus.source === 11
    },

    get isBerica() { // 是否是成都商户
        return this.bussinessStatus.is_berica === 1
    },

    get isChengdu() {
        // 是否是成都商户
        return this.bussinessStatus.is_berica === 1
    },

    get isChengduDxh() {
        // 是否成都点下户，1是，0否
        return this.bussinessStatus.is_berica_dxh === 1
    },

    /**
     * 隐藏式通知。检测系统信息完整性，用户信息是否完整。
     */
    getSysCompleteData() {
        if (this.sysCompleteData !== null) {
            return new Promise(resolve => resolve(this.sysCompleteData))
        }

        return this.fetchSysCompleteData()
    },

    fetchSysCompleteData() {
        return Promise.all([this.checkEnterprise(), this.checkBoxOffline()]).then(res => {
            const sysCompleteData = { ...(res[0] || {}), ...(res[1] || {}) }
            this.sysCompleteData = sysCompleteData
            return sysCompleteData
        })
    },

    // 检查系统信息完整性
    checkEnterprise() {
        return new Promise(resolve => {
            request({
                url: apis.checkEnterprise,
                unforeseen(error) {
                    console.error('ajax.error', error)
                    resolve({
                        existProject: 1,
                        defaultProject: 1,
                        enterpriseInfo: 1,
                        emptyQuota: 1,
                        noNewVideo: 1,
                        noAlarmStock: 1
                    })
                }
            }).then(res => resolve(res))
        })
    },

    // 检查盒子离线时长
    checkBoxOffline() {
        return new Promise(resolve => {
            request({
                url: apis.checkBoxOffline,
                unforeseen(error) {
                    console.error('ajax.error', error)
                    resolve({ boxOffline: 0 })
                },
                ext: {
                    codes: ['0', '1'],
                    handle: res => {
                        resolve({
                            boxOffline: res.code
                        })
                    }
                }
            })
        })
    },

    // 检查票量情况
    checkTicketSum() {
        return new Promise(resolve => {
            request({
                url: apis.checkTicketSum,
                unforeseen() {
                    console.error('ajax.error', error)
                    resolve({ ticketCount: 1 })
                },
                ext: {
                    codes: ["0", "1"],
                    handle: res => {
                        resolve({
                            ticketCount: res.code === 0 ? 1 : 0
                        })
                    },
                },
            })
        })
    },

    updateSysCompleteData(key, value = 0) {
        if (this.sysCompleteData) {
            this.sysCompleteData[key] = value
        }
    },

    setQuotaWarn(warn) {
        this.quotaWarn = warn
    },

    /**
     * 自研插件渠道税盘状态、余票查询
     * @param orderSn 订单号，审核开票动态码开票时传
     * @param type 默认1 静态码动态码开票，2在线人工等没有先生成存订单号的方式
     * @param invoiceType 发票类型，0|电子发票 1|纸普票 2|纸专票
     */
    checkPluginStatus(orderSn, type, invoiceType) {
        return request({
            url: apis.getPluginStatus,
            method: 'post',
            data: {
                order_sn: orderSn,
                type,
                invoice_type: invoiceType
            }
        })
    }
});

export default store;

